import { Link } from 'react-router-dom';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntries from './components/CategoryEntries';
import MovieCard from '@/components/feature/MovieCard';
import { MEDIA_LIST } from '@/mocks/media';

export default function Home() {
  const featured = MEDIA_LIST.filter((item) => item.backdrop).slice(0, 5);
  const latest = [...MEDIA_LIST]
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
    .slice(0, 12);
  const hot = [...MEDIA_LIST].sort((a, b) => b.views - a.views).slice(0, 6);

  return (
    <div className="w-full">
      <HeroCarousel items={featured} />

      <CategoryEntries />

      <section className="w-full px-4 md:px-8 pb-4">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl">最新影视推荐</h2>
            <p className="text-sm text-foreground-500 mt-1">同步更新近期上线的电影与剧集，第一时间发现好片</p>
          </div>
          <Link to="/category/movie" className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer">
            查看全部 <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>
        {latest.length === 0 ? (
          <div className="py-16 text-center text-foreground-500 border border-dashed border-background-300 rounded-lg">
            暂无推荐影视，敬请期待
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
            {latest.map((item) => (
              <MovieCard key={item.id} item={item} />
            ))}
          </div>
        )}
      </section>

      <section className="w-full px-4 md:px-8 py-12 md:py-16 mt-8 bg-background-100">
        <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-8 lg:gap-10">
          <div>
            <div className="mb-6">
              <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl">热门影视精选</h2>
              <p className="text-sm text-foreground-500 mt-1">根据全站热度整理，点击率与人气双高的口碑之作</p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 md:gap-5">
              {hot.map((item) => (
                <MovieCard key={item.id} item={item} />
              ))}
            </div>
          </div>

          <aside className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6 lg:sticky lg:top-24 h-fit">
            <div className="flex items-center gap-2 mb-5">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-bar-chart-2-line"></i>
              </span>
              <h3 className="font-heading font-bold text-foreground-950 text-lg">热播排行榜</h3>
            </div>
            <ol className="space-y-1">
              {hot.map((item, i) => (
                <li key={item.id}>
                  <Link to={`/detail/${item.id}`} className="flex items-center gap-3 py-2.5 px-2 -mx-2 rounded-md hover:bg-background-100 transition-colors cursor-pointer">
                    <span
                      className={`w-6 h-6 shrink-0 flex items-center justify-center rounded-md text-xs font-bold ${
                        i < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      {i + 1}
                    </span>
                    <span className="flex-1 min-w-0 text-sm text-foreground-800 truncate">{item.title}</span>
                    <span className="flex items-center gap-1 text-xs text-accent-700 font-semibold shrink-0">
                      <i className="ri-fire-line"></i>
                      {(item.views / 10000).toFixed(0)}万
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
            <Link
              to="/category/tv"
              className="mt-5 w-full inline-flex items-center justify-center gap-1 px-4 py-2.5 rounded-md border border-primary-200 bg-primary-50 text-primary-700 text-sm font-medium hover:bg-primary-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              浏览更多热播剧集 <i className="ri-arrow-right-s-line"></i>
            </Link>
          </aside>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="rounded-lg bg-primary-950 text-background-50 px-5 py-10 md:px-12 md:py-14">
          <div className="grid grid-cols-1 lg:grid-cols-[3fr_2fr] gap-8 items-center">
            <div>
              <h2 className="font-heading font-bold text-2xl md:text-3xl">关于「朋友的妈妈在线」</h2>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200">
                朋友的妈妈在线是一个专注于最新电影与电视剧资源聚合的观影导航平台。我们覆盖动作、喜剧、爱情、科幻、悬疑、古装等多元类型，
                按地区、年份、题材进行细致分类，让每一位追剧、观影的用户都能快速找到想看的内容。平台持续更新热门影视作品，提供清晰的浏览与搜索体验。
              </p>
              <div className="mt-7 flex flex-wrap gap-3">
                <Link
                  to="/category/movie"
                  className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-accent-500 text-primary-950 text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-film-line"></i> 进入电影频道
                </Link>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 px-5 py-3 rounded-md border border-background-50/30 text-background-50 text-sm font-semibold hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-information-line"></i> 了解我们
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {[
                { num: '24+', label: '影视作品' },
                { num: '9', label: '覆盖地区' },
                { num: '19', label: '题材类型' },
                { num: '每日', label: '持续更新' },
              ].map((s) => (
                <div key={s.label} className="rounded-lg bg-primary-900 p-5 text-center">
                  <p className="font-heading font-bold text-accent-400 text-2xl md:text-3xl">{s.num}</p>
                  <p className="mt-1 text-xs md:text-sm text-background-300">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}